import { useQuery } from '@tanstack/react-query';
import shoppingSubscriptionService from 'v2/services/shopping/subscription';

import type { IShoppingSubscription } from 'v2/interfaces/shopping';

import type { UseQueryOptions } from '@tanstack/react-query';

function useSubscription(subscriptionId: number, options?: UseQueryOptions<IShoppingSubscription>) {
  return useQuery(
    ['subscription', subscriptionId],
    ({ queryKey }) => {
      const [, subscriptionId] = queryKey;
      return shoppingSubscriptionService.getSubscription(subscriptionId as number).toPromise();
    },
    options
  );
}

export { useSubscription };
